module.exports = __webpack_public_path__ + "img/star-map_bg-1.0d52a45.png";